import {produce} from 'immer';
import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import moment, {type Moment} from 'moment';
import {type CanceledError} from 'axios';

import {type YTError} from '../../../../../../@types/types';

export interface DownloadItem {
    id: string;
    startTime?: Moment;

    loading?: boolean;
    loaded?: boolean;

    error?: YTError | CanceledError<any>;
}

export interface DownloadManagerState {
    downloads: Record<string, DownloadItem | undefined>;
}

const initialState: DownloadManagerState = {
    downloads: {},
};

const reducers = {
    onRequest(state: DownloadManagerState, action: PayloadAction<Pick<DownloadItem, 'id'>>) {
        return produce(state, (draft: DownloadManagerState) => {
            draft.downloads[action.payload.id] = {
                ...draft.downloads[action.payload.id],
                id: action.payload.id,
                startTime: moment(),
                loading: true,
                loaded: false,
            };
        });
    },
    onFailure(
        state: DownloadManagerState,
        action: PayloadAction<Pick<DownloadItem, 'id' | 'error'>>,
    ) {
        return produce(state, (draft: DownloadManagerState) => {
            draft.downloads[action.payload.id] = {
                ...draft.downloads[action.payload.id],
                id: action.payload.id,
                error: action.payload.error,
                loaded: false,
                loading: false,
            };
        });
    },
    onSuccess(state: DownloadManagerState, action: PayloadAction<Pick<DownloadItem, 'id'>>) {
        return produce(state, (draft: DownloadManagerState) => {
            draft.downloads[action.payload.id] = {
                ...draft.downloads[action.payload.id],
                id: action.payload.id,
                loading: false,
                loaded: true,
            };
        });
    },
    onCleanup(state: DownloadManagerState, action: PayloadAction<Pick<DownloadItem, 'id'>>) {
        return produce(state, (draft: DownloadManagerState) => {
            delete draft.downloads[action.payload.id];
        });
    },
};

const downloadManagerSlice = createSlice({
    name: 'downloadManager',
    initialState,
    reducers,
});

export const downloadManagerActions = downloadManagerSlice.actions;
export const downloadManager = downloadManagerSlice.reducer;
